import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import CompanyLogo from '/Users/divasmishra/Desktop/fitness-tracker/src/Assests/company.png';

const NavbarProfile = () => {
  const { user, logout } = useAuth();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [showMenu, setShowMenu] = useState(false); // State for toggling menu on smaller screens

  const handleLogout = () => {
    logout();
    window.location.href = '/login';
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const toggleMenu = () => {
    setShowMenu(!showMenu);
    setDropdownVisible(false); // Close dropdown when menu is toggled
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={CompanyLogo} alt="Company Logo"/>
      </div>
      {/* Navbar links for larger screens */}
      <ul className={`nav-links ${showMenu ? 'active' : ''}`}>
        <li><Link to="/">Home</Link></li>
        <li><a href="#contact">Contact</a></li>
        <li><a href="#Training Plans">Training Plans</a></li>
        <li><Link to="/">Diet Plans</Link></li>
      </ul>
      {/* Dropdown menu for user profile */}
      <div className="navbar-profile-dropdown">
        <span className="navbar-username" onClick={toggleDropdown}>
          {user ? user.name || user.username : 'Guest'}
        </span>
        {dropdownVisible && (
          <div className="dropdown-menu show">
            {user ? (
              <>
                <a href="/profile">{user.name || user.username}</a>
                <div>
                  <button onClick={handleLogout}>Log Out</button>
                </div>
              </>
            ) : (
              <>
                <a href="/login">Login</a>
                <a href="/signup">Sign Up</a>
              </>
            )}
          </div>
        )}
      </div>
      {/* Toggling button for smaller screens */}
      <div className={`menu-toggle ${showMenu ? 'active' : ''}`} onClick={toggleMenu}>
        <div className="menu-button">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      {/* Menu for smaller screens */}
      {showMenu && (
        <ul className="nav-links">
          <li><Link to="/">Home</Link></li>
          <li><a href="#contact">Contact</a></li>
          <li><a href="#Training Plans">Training Plans</a></li>
          <li><Link to="/#DietPlanner">Diet Plans</Link></li>
        </ul>
      )}
    </nav>
  );
};

export default NavbarProfile;
